import * as m from "./../../../dist/es2015/plugins/json.js";
export const am5plugins_json = m;